import React, { useEffect, useMemo } from 'react';
import { roomsQuery, roomsService } from '../../state';
import { useObservable, useRoomTypeById } from '../utils';
import { AppColors } from '../theme';

interface Props {
  propertyId: string;
  roomTypeId: string;
  roomId?: string;
  hideRoomNumber?: boolean;
}

export const RoomDisplay: React.FC<Props> = props => {
  const { roomId, hideRoomNumber } = props;
  if (roomId) {
    return (
      <RoomNumberDisplay {...props} roomId={roomId} hideRoomNumber={hideRoomNumber ?? false} />
    );
  } else {
    return <RoomTypeOnlyDisplay {...props} />;
  }
};

const RoomTypeOnlyDisplay: React.FC<Omit<Props, 'roomId'>> = ({ roomTypeId }) => {
  const roomType = useRoomTypeById(roomTypeId);

  if (!roomType) return null;

  return <>{roomType.name}</>;
};

const RoomNumberDisplay: React.FC<Required<Props>> = ({
  propertyId,
  roomId,
  hideRoomNumber,
  roomTypeId,
}) => {
  useEffect(() => {
    roomsService.getRoomNumber(propertyId, roomId);
  }, [propertyId, roomId]);

  const query = useMemo(() => roomsQuery.selectEntity(roomId), [roomId]);
  const room = useObservable(query);

  if (!room) return null;

  const roomTypeStyle =
    hideRoomNumber && roomTypeId !== room.roomTypeId ? { color: AppColors.Green } : {};

  return (
    <>
      <span style={roomTypeStyle}>{room.roomType.name}</span>
      <>
        {!hideRoomNumber && (
          <>
            <span> / {room.roomNumber}</span>
          </>
        )}
      </>
    </>
  );
};
